import { SET_PERMISSONS, SET_SUB_ADMIN_PERMISSONS, SET_SUB_ADMIN_TYPE } from "../types/types";

export const setPermissons = value => {
  return {
    type: SET_PERMISSONS,
    payload: { data: value }
  };
};
export const setStaffGurationFilter = value => {
  return {
    type: "SET_STAFF_DASH_FILTER",
    payload: { data: value }
  };
};
export const setSubAdminPermissions = value => {
  return {
    type: SET_SUB_ADMIN_PERMISSONS,
    payload: { data: value }
  };
};
export const setSubAdminType= value => {
  return {
    type: SET_SUB_ADMIN_TYPE,
    payload: { data: value }
  };
};